import i18n from '@/helpers/i18n';

// Étape 5 (2026-11-02) : une seule fonction pour les montants du back-office, comme l'app caissier : « 12 500 FCFA » en
// français (espace fine insécable entre les milliers), « 12,500 FCFA » en anglais. Franc CFA sans décimales : arrondi.
const NARROW_NO_BREAK_SPACE = ' ';
const NO_BREAK_SPACE = ' ';

export const formatMoney = (value: unknown, language: string = i18n.language): string => {
  const amount = Math.round(Number(value) || 0);
  const digits = Math.abs(amount)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, language === 'en' ? ',' : NARROW_NO_BREAK_SPACE);
  return `${amount < 0 ? '-' : ''}${digits}${NO_BREAK_SPACE}FCFA`;
};

/** Ancien nom, gardé pour les écrans existants. */
export const formatCurrency = (value: unknown) => formatMoney(value);

/** Colonnes d'un tableau antd déclarées avec des clés de traduction : titres traduits à l'affichage (sous-colonnes comprises). */
export const translateColumns = <T extends { title?: any; children?: T[] }>(columns: T[]): T[] =>
  columns.map(column => ({
    ...column,
    title: typeof column.title === 'string' ? i18n.t(column.title) : column.title,
    ...(column.children ? { children: translateColumns(column.children) } : {}),
  }));
